import coin1 from '../../assets/images/coin-1-print.png'
import coin5 from '../../assets/images/coin-5-print.png'
import coin10 from '../../assets/images/coin-10-print.png'
import coin25 from '../../assets/images/coin-25-print.png'
import coin50 from '../../assets/images/coin-50-print.png'
import AppConstatnt from '../../config/app.constants';


class RouteSheetController {
  /*@ngInject*/
  constructor(Auth, $state, DateUtil, User, UserService, RouteService, $translate, $filter, $q, SetupService, LocationService, $rootScope) {
    this.$translate = $translate
    this.Auth = Auth
    this.$state = $state
    this.DateUtil = DateUtil
    this.User = User
    this.RouteService = RouteService
    this.LocationService = LocationService
    this.SetupService = SetupService
    this.$filter = $filter;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.routePrefix = null;
    this.routeSheet = []
    this.fullRouteSheet = [];
    this.routes = []
    this.routeList = [];
    this.branchName = " ";
    this.allData = "";
    this.model = {
      date: null,
      // day: null ,
      branchId: this.User.getUser().branchId,
    }
    // this.model.route = ''
    // this.model.date = new Date('2017-01-01')
    this.noDataFound = false;
    this.$rootScope.$broadcast('routeChange', '/app/route-sheet');
  }

  initBarcodeOptions() {
    this.barcodeOptions = {
      format: 'CODE128',
      lineColor: '#000000',
      width: 2,
      height: 50,
      displayValue: true,
      fontOptions: '',
      font: 'monospace',
      textAlign: 'center',
      textPosition: 'bottom',
      textMargin: 2,
      fontSize: 20,
      background: '#ffffff',
      margin: 0,
      marginTop: undefined,
      marginBottom: undefined,
      marginLeft: undefined,
      marginRight: undefined,
      valid: function (valid) { }
    }
  }

  // do not allow to paste string into datepicker
  dontAllow(element) {
    element.on('cut copy paste', function (event) {
      event.preventDefault();
    });
  }

  // get tanker data
  loadRoutes() {
    const onlyHoldRoutes = {
      queryJSON: {
        rules: [
          {
            field: 'holdRoute',
            condition: '=',
            data: '0'
          },
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          },
        ],
        operator: 'AND'
      }
    }
    return onlyHoldRoutes.queryJSON.rules.length ? onlyHoldRoutes : null;
  }

  $onInit() {
    this.SetupService.get(this.User.getUser().branchId)
      .then((data) => {
        const date = this.DateUtil.getUTCDate(data.currentVaultDate);
        this.valutDate = moment(date).format('YYYY-MM-DD');
        this.model.date = moment(this.valutDate).toDate();
        this.branchName = data.branch.description;
        this.routePrefix = data.prefixes.route[0];
      })
      .catch((err) => {
        this.error = err.message;
      })

    this.getRouteData();
  }

  // load routeData
  getRouteData(searchKey, offset) {
    let loadRouteData = '';
    if (searchKey) {
      const searchObj = {
        queryText: '%' + searchKey + '%',
        isQuery: false
      }
      loadRouteData = searchObj;
    }
    else {
      loadRouteData = this.loadRoutes();
    }
    this.RouteService.all(loadRouteData, offset, AppConstatnt.defaultPageLimit)
      .then((data) => {

        if (offset === 0 || offset == undefined) {
          this.totalRecord = data.total;
          this.routeList = this.mappingRouteData(data.results);
        }
        else {
          const routes = this.mappingRouteData(data.results);
          this.routeList = this.routeList.concat(routes);
        }
      })
  }

  mappingRouteData(routes) {
    return routes.map((route) => {
      return {
        Key: route.id + " | " + route.name,
        Value: route.id
      }
    });
  }

  print() {
    let obj = {
      data: this.routeSheet,
      model: this.model,
      totalBags: this.totalBags,
      branchName: this.branchName,
      branchId: this.allData.branch,
      driverId: this.allData.driverId,
      messengerId: this.allData.messengerId,
      guardId: this.allData.guardId,
      vehicleId: this.allData.vehicleId,
      totalKeys: this.totalKeys,
      generateSheet: true
    }
    let url = this.$state.href('print')
    window.w = window.open(url, '_blank');

    window.w.printData = obj;
  }

  show() {
    if (!this.model.route) {
      return;
    }
    this.model.barcodeId = this.routePrefix ? this.routePrefix + this.model.route.Value : this.model.route.Value
    this.loadData(this.model.route.Value, this.model.date, this.model.branchId)
  }

  computeData(routeSheet) {
    let totalBags = 0;
    let coinTypeOrder = ['B', 'H', 'L'];
    let totalKeys = 0;
    routeSheet.forEach((r) => {
      let sortedCoinsOrder = Object.keys(r.totals);

      totalBags += r.totalCashShipments || 0;
      if (r.keyNum) {
        totalKeys++;
      }

      sortedCoinsOrder = sortedCoinsOrder.sort((coinA, coinB) => {
        let coinAVal = coinA.indexOf('1$') >= 0 ? 100 : parseInt(coinA);
        let coinBVal = coinB.indexOf('1$') >= 0 ? 100 : parseInt(coinB);;

        //add weights for coin types i.e. B, H and L
        coinAVal += coinTypeOrder.indexOf(coinA.charAt(2));
        coinBVal += coinTypeOrder.indexOf(coinB.charAt(2));

        return coinAVal - coinBVal;
      });

      r.sortedCoinsOrder = sortedCoinsOrder;
      r.coinTypes = r.sortedCoinsOrder.length;

      // dont call bagStack in ngRepeat as it returns fresh array every time it will lead to digest cycle error
      r.bagStack = this.bagStack(r.coinTypes, r.trackingIds);
      // delete r.trackingIds;
    });

    this.totalBags = totalBags;
    this.totalKeys = totalKeys;
  }

  loadData(route, date, branchId) {
    // var day = moment(date).format('ddd');
    this.loading = true;
    this.RouteService.sheet(route, date, branchId)
      .then((data) => {
        this.noDataFound = true;
        this.loading = false;
        this.allData = data;
        this.fullRouteSheet = data.records;
        this.filterData();
      })
      .catch((err) => {
        this.loading = false;
        console.log('Some error', err)
      })
  }

  bagStack(coinTypes, bags) {
    const array = []
    let i, j, chunk = 0;

    // column height is dependent on coinTypes so change the chunk size accordingly
    if (coinTypes > 12) {
      chunk = 6;
    }
    else if (coinTypes > 6 && coinTypes <= 12) {
      chunk = 4;
    }
    else {
      chunk = 3;
    }

    for (i = 0, j = bags.length; i < j; i += chunk) {
      array.push(bags.slice(i, i + chunk))
    }

    return array
  }

  icon(key) {
    key = key.substr(0, key.length - 1);
    switch (key) {
      case '01':
        return coin1
      case '05':
        return coin5
      case '25':
        return coin25
      case '50':
        return coin50
      case '10':
        return coin10
      default:
        return coin1
    }
  }

  // filter routeSequence data according to locationType
  filterData(branchId) {

    let routeSheet = [];
    const locationTypes = ["NO_SHIP_NO_GO"];

    if (this.printSeq) {
      routeSheet = this.fullRouteSheet.slice().filter((r) => {
        return r.seq == this.printSeq;
      });
    }
    else {
      routeSheet = this.fullRouteSheet.slice();
    }
    this.computeData(routeSheet);
    this.routeSheet = routeSheet;
    this.branchId = this.allData.branch;
    this.driverId = this.allData.driverId;
    this.messengerId = this.allData.messengerId;
    this.guardId = this.allData.guardId;
    this.vehicleId = this.allData.vehicleId
  }
}

export default RouteSheetController;/**/



// WEBPACK FOOTER //
// ./client/app/components/routeSheet/routeSheet.controller.js